import axios from 'axios'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'

const setup = () => {
  const token = localStorage.getItem('token')

  const appStore = useAppStore()
  const authStore = useAuthStore()

  if (token) {
    authStore.setToken(token)
  }

  axios.interceptors.request.use(
    (request) => {
      appStore.startLoad()
      return request
    },
    (error) => {
      appStore.stopLoad()
      return Promise.reject(error)
    },
  )

  axios.interceptors.response.use(
    (response) => {
      appStore.stopLoad()
      return response
    },
    (error) => {
      appStore.stopLoad()
      switch (error.response.status) {
        case 400: {
          if (error.response.data.message) {
            appStore.showMessage(error.response.data.message)
          }
          break
        }
        case 401: {
          localStorage.removeItem('token')
          // eslint-disable-next-line no-restricted-globals
          location.reload()
          break
        }
        default: break
      }
      return Promise.reject(error)
    },
  )
}

export default setup
